export default __webpack_public_path__ + "dist/img/no-image.png";